export default function CustomTransportProvider(bearer_token) {
  const extractHeaders = function (headersString) {
    var arr = headersString.trim().split(/[\r\n]+/);
    return arr.map(line => {
      var parts = line.split(": ");
      var name = parts.shift();
      var value = parts.join(": ");
      var header = new com.ts.mobile.sdk.TransportHeader();
      header.setName(name);
      header.setValue(value);
      return header;
    });
  };
  const sendRequest = function (request) {
    let newAuthHeader = new com.ts.mobile.sdk.TransportHeader(); // initialize replacement auth header as new object
    let bearerTokenValue = bearer_token; // can be fed in as a variable (up to you how you want to consume)
    let bearerTokenName = "Bearer "; // include seperator string for last entry

    let appendedAuthValue = bearerTokenName + bearerTokenValue + " "; /// build the new value to be appended
    newAuthHeader.setName("Authorization"); // set name for replacement header
    newAuthHeader.setValue(appendedAuthValue);
    if (request.getHeaders().length === 0) {
      request.getHeaders().push(newAuthHeader); // insert/replace Authorization header with new appended version
    }
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      let rejectWithCommunicationError = () => {
        reject();
      };
      xhr.open(request.getMethod(), request.getUrl(), true);
      //xhr.withCredentials = true;
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          // DONE
          try {
            if (0 === xhr.status) {
              /*  status 0 under readyState 4 may happen for three scenarios:
                                            Case 1: url is an invalid address at an existing server
                                            Example: http://xyz.google.com where the server responds but it is not a valid request
                                            Case 2: url is to a non-existing server ip address
                                            Example: http://192.168.8.6 on my local network where there is nothing to respond
                                            Case 3: url is a valid address where access-control-allow-origin is NOT set
                                            Example: http://192.168.8.247 where I have a server without Access-Control-Allow-Origin: * set in the header
                                            */
              return reject();
            }
            var data = JSON.parse(xhr.responseText);
            var response = new com.ts.mobile.sdk.TransportResponse();
            response.setStatus(xhr.status);
            response.setMethod(request.getMethod());
            response.setHeaders(this.extractHeaders(xhr.getAllResponseHeaders()));
            response.setBodyJson(xhr.responseText);
            resolve(response);
          } catch (ex) {
            rejectWithCommunicationError();
          }
        }
      };
      xhr.onerror = () => {
        rejectWithCommunicationError();
      };
      request.getHeaders().forEach(header => {
        // set authorization header
        // cannot be deleted once created.
        // this effectively removes default values and
        if (header.getName() == "Authorization") {
          xhr.setRequestHeader("Authorization", appendedAuthValue);
        } else {
          xhr.setRequestHeader(header.getName(), header.getValue());
        }
      });
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(request.getBodyJson());
    });
  };
  return {
    sendRequest: sendRequest,
    extractHeaders: extractHeaders
  };
}